import { useEffect } from "react";
import { useTranslation } from "@/hooks/localization/useTranslations";
import { useUploadFiles } from "../../common-form-builder/common-fields/hook-upload-files/hook-multiple-files/useUploadFiles";
import { TempFile } from "../../common-form-builder/common-fields/hook-upload-files/upload-files-helpers/upload";
import { getIsImage } from "../../common-form-builder/common-fields/hook-upload-files/HookUploadOneFile";
import ToastForUpload from "../../common-form-builder/common-fields/hook-upload-files/upload-files-helpers/ToastForUpload";
import FileThumbmailSlider from "../../common-form-builder/common-fields/hook-upload-files/hook-multiple-files/FileThumbmailSlider";
import FileThumbmail from "../../common-form-builder/common-fields/hook-upload-files/upload-files-helpers/file-thumbmail/FileThumbmail";
import SvgUploadFiles from "../../common-form-builder/common-fields/hook-upload-files/SvgUploadFiles";
import InputErrorMsg from "../../common-form-builder/form-builder-helpers/InputErrorMsg";
import {
  Control,
  Controller,
  FieldValues,
  UseFormSetValue,
} from "react-hook-form";
interface Props {
  name: string;
  value: string[];
  setValue: UseFormSetValue<FieldValues>;
  required?: boolean;
  hint: string;
  error: string;
  control: Control<FieldValues, any>;
}
const AttatchmentsInput: React.FC<Props> = ({
  value,
  setValue,
  name,
  required,
  hint,
  error,
  control,
}) => {
  const {
    filesUrls,
    setFilesUrls,
    msgErr,
    setMsgErr,
    handleUpload,
    handleRemove,
  } = useUploadFiles();
  const t = useTranslation();

  const initState: TempFile[] =
    value && Array.isArray(value)
      ? value
          ?.filter((val) => typeof val === "string")
          .map((val: string, idx: number): TempFile => {
            return { id: idx, url: val, name: val, isImage: getIsImage(val) };
          })
      : [];
  useEffect(() => {
    setTimeout(() =>
      setValue(
        name,
        filesUrls.filter((f) => f.url !== ""),
      ),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filesUrls]);
  useEffect(() => {
    setFilesUrls(initState);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);
  return (
    <div>
      {msgErr.length > 0 && (
        <ToastForUpload
          message={msgErr}
          show={msgErr.length > 0}
          setShow={() => setMsgErr([])}
        />
      )}
      {filesUrls?.length > 0 && (
        <FileThumbmailSlider spacing={2}>
          {filesUrls?.map((f, index) => (
            <FileThumbmail
              key={f.id}
              file={f}
              onRemoveClick={() => handleRemove(index)}
            />
          ))}
        </FileThumbmailSlider>
      )}
      <label className="upload-btn">
        <Controller
          name={name}
          control={control}
          rules={{
            required: required && t.this_field_is_required,
          }}
          render={({}) => (
            <input
              type="file"
              multiple={true}
              accept="image/*,video/*"
              onChange={(e) =>
                handleUpload((e.target as HTMLInputElement).files)
              }
            />
          )}
        />

        <div>
          <SvgUploadFiles /> {hint}
        </div>
      </label>
      {hint && <div className="field-hint">{hint}</div>}
      {error && <InputErrorMsg errorMsg={error} />}
    </div>
  );
};

export default AttatchmentsInput;
